import styled from '@emotion/styled'
import { Button } from 'ui-components/Button'

export const Address = styled.div`
  display: grid;
  grid-template-columns: auto 30px;
`

export const EditButton = styled(Button)`
  height: 30px;
`
